import 'formdata-polyfill'; // import FormData into global. FormData does not work in safari worker
import { disablePostCommentsPromisified } from '../../comments/actions/disable-post-comments';
import { enablePostCommentsPromisified } from '../../comments/actions/enable-post-comments';
import { addTextColor } from '../../post-page/actions/rce-settings';
import { search, clearSearchResults } from '../../search/actions/search';
import { createPostDraftPromisified } from '../actions/create-post-draft';
import { pinPostPromisified } from '../actions/pin-post';
import { publishPostPromisified } from '../actions/publish-post';
import { saveAndPublishPostPromisified } from '../actions/save-and-publish-post';
import { savePostDraftPromisified } from '../actions/save-post-draft';
import { submitPostForModerationPromisified } from '../actions/submit-post-for-moderation';
import { subscribePromisified } from '../actions/subscribe';
import { unpinPostPromisified } from '../actions/unpin-post';
import { unsubscribePromisified } from '../actions/unsubscribe';
import { uploadImagePromisified } from '../actions/upload-image-new';
import {
  requestFileUploadUrlPromisified,
  requestFileDownloadUrlPromisified,
} from '../actions/wix-media';
import { incrementPostLikeCount } from '../store/post-likes/post-likes-actions';
import { openPostSettings } from '../store/post-settings/open-post-settings';

export default {
  uploadImagePromisified,
  saveAndPublishPostPromisified,
  addTextColor,
  incrementPostLikeCount,
  createPostDraftPromisified,
  publishPostPromisified,
  savePostDraftPromisified,
  openPostSettings,
  subscribePromisified,
  unsubscribePromisified,
  unpinPostPromisified,
  pinPostPromisified,
  disablePostCommentsPromisified,
  enablePostCommentsPromisified,
  requestFileUploadUrlPromisified,
  requestFileDownloadUrlPromisified,
  search,
  clearSearchResults,
  submitPostForModerationPromisified,
};
